"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class EventHandler {
    constructor() {
        this.eventList = {};
    }
    /**
     * Add event listener
     */
    on(event, handler) {
        if ((event in this.eventList) === false) {
            this.eventList[event] = [];
        }
        this.eventList[event].push(handler);
        return this;
    }
    /**
     * Remove event listener
     */
    off(event, handler) {
        if ((event in this.eventList) === false) {
            return this;
        }
        // no handler, remove all callables from function
        if (handler === undefined) {
            delete this.eventList[event];
            return this;
        }
        // if index was found, remove entry from array
        const index = this.eventList[event].indexOf(handler);
        if (index > -1) {
            this.eventList[event].splice(index, 1);
        }
        return this;
    }
    /**
     * Fire event
     */
    trigger(event, extraParameters) {
        if ((event in this.eventList) === false) {
            return this;
        }
        const callables = this.eventList[event];
        for (const handler of callables) {
            // if response is explicitly true, stop propagation
            try {
                if (handler.apply(this, extraParameters) === true) {
                    break;
                }
            }
            catch (exception) {
                console.error(exception);
            }
        }
        return this;
    }
}
exports.default = EventHandler;
//# sourceMappingURL=EventHandler.js.map